module.exports = __webpack_public_path__ + "85b615379efa6cdd5b0c2b14c85595b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/diamond/images/clarityScale/VS1@2x.png
// module id = 812
// module chunks = 0